import { Link, Navigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useSession } from "@/hooks/useSession";

export default function Landing() {
  const { isSignedIn, isLoading } = useSession();

  if (!isLoading && isSignedIn) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-950 via-purple-900 to-pink-950 flex items-center justify-center p-4">
      <Card className="max-w-xl w-full bg-white/95 backdrop-blur shadow-2xl">
        <CardHeader className="text-center space-y-4">
          <div className="text-6xl" role="img" aria-label="Detective">
            🕵️
          </div>
          <CardTitle className="text-4xl bg-gradient-to-r from-pink-500 to-purple-500 bg-clip-text text-transparent">
            Cryptolect
          </CardTitle>
          <CardDescription className="text-base">
            Cipher-gated content for publishers and the agents that read for
            them. Sign in to create a cipher, share it with verified readers,
            and watch decoded access happen in real time.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col items-center gap-3">
          <Link to="/login" className="w-full max-w-xs">
            <Button className="w-full bg-gradient-to-r from-pink-500 to-purple-500 hover:opacity-90">
              Get started
            </Button>
          </Link>
          <p className="text-xs text-muted-foreground">
            Already have an account? Use the same button.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
